import React, {useContext} from 'react';
import { Outlet, Link } from "react-router-dom";
import helpers from '../../services/helpers';
import images from '../../services/images';
import { MdHandyman, MdManageAccounts } from "react-icons/md";
import FormContext from '../../services/formContext';

export default function SideMenuPolarServ({menu}){
    const {
        account
    } = useContext(FormContext);

    function setMenuOpen(menu_id = [], current_page = '', parent_menu=false){
        let classes = 'nav-item'

        if(menu_id.includes(current_page)){
            classes += ' menu-open'
        }

        return classes;
    }


    function setCurrentMainMenu(menu_id = [], current_page = '', parent_menu=false){
        let classes = 'pointer nav-link nav-link-main'

        if(menu_id.includes(current_page)){
            classes += ' active'

            // if(parent_menu){
            //     classes += 'bg-navy text-light'
            // }
            // else{
            //     classes += 'bg-secondary'
            // }
        }

        return classes;
    }

    function setCurrentSubMenu(menu_id = [], current_page = '', parent_menu=false){
        let classes = 'nav-link nav-link-main'

        if(menu_id.includes(current_page)){
            classes += ' active'
        }

        return classes;
    }

    function AccessPermission({ requiredPermissions=[], children }){
        const authorized = helpers.checkPermissions(requiredPermissions, account.permissions);
        //const authorized = requiredPermissions.some(p => account.permissions.includes(p));

        if(requiredPermissions.length && !authorized){
            return
        }
    
        return children;
    }

    function setMenuOpen(menu_id = [], current_page = ''){
        let classes = 'nav-item'

        if(menu_id.includes(current_page)){
            classes += ' menu-is-opening menu-open'
        }
        return classes;
    }

    function getStoreName(){
        let store_data = helpers.getDefaultStore()

        if(store_data.hasOwnProperty('name')){
            return store_data.name;
        }
    }

    return (
        <>
        {/* Main Sidebar Container */}
        <aside className="main-sidebar elevation-4 sidebar-light-dark">
        {/* <aside className="main-sidebar sidebar-dark-light elevation-4"> */}
            {/* Brand Logo */}
            <Link className="brand-link d-flex align-items-center" to="/">
                <img src={images.topventory_icon} alt="Icon"  className="brand-image" />
                <img className='brand-text' src={images.topventory_text_only} alt="Logo" />
                {/* <div className='brand-text'>WV SERVICES</div> */}
                <small className='ml-1'><sup>BETA</sup></small>
            </Link>

            {/* Sidebar */}
            
            <div className="sidebar">
                {/* Sidebar Menu */}
                <nav className="mt-2">
                    { 
                        !helpers.isAuthenticated() ?
                        <ul className="nav nav-pills nav-sidebar flex-column nav-collapse-hide-child nav-child-indent nav-compact" data-widget="treeviews" role="menu" data-accordion="false">
                            <li className="nav-item">
                                <Link className={setCurrentMainMenu(['home'], menu, true)} to="/login">
                                    <i className="fas fa-sign-in-alt mr-3"></i>
                                    <p>Login</p>
                                </Link>
                            </li>
                        </ul> : ''
                    }
                    
                    { 
                        helpers.isAuthenticated() ?
                        <ul className="nav nav-pills nav-sidebar flex-column nav-collapse-hide-child nav-child-indent nav-compact" data-widget="treeviews" role="menu" data-accordion="false">
                            <li className={setMenuOpen(['home', 'customer-dashboard'], menu, true)}>
                                <a className={setCurrentMainMenu(['home', 'customer-dashboard'], menu, true)}>
                                    <i className="nav-icon fas fa-tachometer-alt mr-2" />
                                    <p>Dashboard <i className="right fas fa-angle-left" /></p>
                                </a>
                                <ul className="nav nav-treeview">
                                    <li className="nav-item">
                                        <Link className={setCurrentSubMenu(['home'], menu, true)} to="/dashboard">
                                            <p className='ml-3'>Home</p>
                                        </Link>
                                    </li>

                                    <AccessPermission requiredPermissions={["superAdmin","serviceHubClientMap"]}>
                                    <li className="nav-item">
                                        <Link className={setCurrentSubMenu(['customer-dashboard'], menu, true)} to="/customer-dashboard">
                                            <p className='ml-3'>Customer</p>
                                        </Link>
                                    </li>
                                    </AccessPermission>
                                </ul>
                            </li>

                            <AccessPermission requiredPermissions={["superAdmin","serviceHubView", "serviceHubViewAssgined", "serviceHubCreate", "serviceHubEdit", "serviceHubDelete", "serviceHubSchedule", "serviceHubAssess", "serviceHubAccept", "productUnitView", "productUnitCreate", "productUnitEdit","productUnitDelete"]}>
                                <li className={setMenuOpen(['manage-service-requests', 'manage-product-units', 'manage-service-schedule'], menu, true)}>
                                    <a className={setCurrentMainMenu(['manage-service-requests', 'manage-product-units', 'manage-service-schedule'], menu, true)}>
                                        {/* <i className="nav-icon fa fa-tasks mr-2" /> */}
                                        <MdHandyman size={25} className='mr-2' />
                                        <p>PolarServ <i className="right fas fa-angle-left" /></p>
                                    </a>
                                    <ul className="nav nav-treeview">
                                        <AccessPermission requiredPermissions={["superAdmin","serviceHubView", "serviceHubCreate", "serviceHubEdit", "serviceHubDelete", "serviceHubSchedule", "serviceHubAssess", "serviceHubAccept"]}>
                                        <li className="nav-item">
                                            <Link className={setCurrentSubMenu(['manage-service-requests'], menu, true)} to="/polarserv/service-requests/list">
                                                <p className='ml-3'>Service Request</p>
                                            </Link>
                                        </li>
                                        </AccessPermission>
                                        
                                        <AccessPermission requiredPermissions={["superAdmin","serviceHubViewAssgined", "serviceHubCreate", "serviceHubEdit", "serviceHubDelete", "serviceHubSchedule", "serviceHubAssess", "serviceHubAccept"]}>
                                        <li className="nav-item">
                                            <Link className={setCurrentSubMenu(['manage-service-schedule'], menu, true)} to="/polarserv/service-requests/schedule">
                                                <p className='ml-3'>Schedules</p>
                                            </Link>
                                        </li>
                                        </AccessPermission>

                                        <AccessPermission requiredPermissions={["superAdmin","productUnitView", "productUnitCreate", "productUnitEdit","productUnitDelete"]}>
                                        <li className="nav-item">
                                            <Link className={setCurrentSubMenu(['manage-product-units'], menu, true)} to="/polarserv/product-units/list">
                                                <p className='ml-3'>PolarCare Units</p>
                                            </Link>
                                        </li>
                                        </AccessPermission>
                                    </ul>
                                </li>
                            </AccessPermission>


                            <AccessPermission requiredPermissions={["superAdmin","salesOrderCreate", "salesOrderEdit", "salesOrderDelete", "salesOrderCancel", "invoiceView", "invoiceCreate", "invoiceEdit", "invoiceDelete", "invoiceCancel", "paymentReceiveView", "paymentReceiveCreate","paymentReceiveEdit","paymentReceiveDelete","customerView","customerCreate","customerEdit","customerDelete"]}>
                            <li className={setMenuOpen(['manage-sales', 'manage-sales-form', 'manage-customers', 'couriers', 'manage-invoices', 'manage-payment-receives'], menu, true)}>
                                <a className={setCurrentMainMenu(['manage-sales', 'manage-sales-form', 'manage-customers', 'couriers', 'manage-invoices', 'manage-payment-receives'], menu, true)}>
                                    <i className="nav-icon fas fa-shopping-cart mr-2"></i>
                                    <p>{helpers.getSettingValue(account?.settings, 'sales_group_module_menu_label', 'PolarCRM')} <i className="right fas fa-angle-left" /></p>
                                </a>
                                <ul className="nav nav-treeview">
                                    <AccessPermission requiredPermissions={["superAdmin","salesOrderCreate", "salesOrderEdit", "salesOrderDelete", "salesOrderCancel"]}>
                                    <li className="nav-item">
                                        <Link className={setCurrentSubMenu(['manage-sales'], menu, true)} to="/sales/list">
                                            <p className='ml-3'>{helpers.getSettingValue(account?.settings, 'sales_order_menu_label', 'Sales Order')}</p>
                                        </Link>
                                    </li>
                                    </AccessPermission>

                                    <AccessPermission requiredPermissions={["superAdmin","invoiceView", "invoiceCreate", "invoiceEdit", "invoiceDelete", "invoiceCancel"]}>
                                    <li className="nav-item">
                                        <Link className={setCurrentSubMenu(['manage-invoices'], menu, true)} to="/invoices/list">
                                            <p className='ml-3'>{helpers.getSettingValue(account?.settings, 'invoice_menu_label', 'Invoices')}</p>
                                        </Link>
                                    </li>
                                    </AccessPermission>

                                    <AccessPermission requiredPermissions={["superAdmin","paymentReceiveView", "paymentReceiveCreate","paymentReceiveEdit","paymentReceiveDelete"]}>
                                    <li className="nav-item">
                                        <Link className={setCurrentSubMenu(['manage-payment-receives'], menu, true)} to="/payment-receives/list">
                                            <p className='ml-3'>Payment Receives</p>
                                        </Link>
                                    </li>
                                    </AccessPermission>
                                    
                                    <AccessPermission requiredPermissions={["superAdmin","customerView","customerCreate","customerEdit","customerDelete"]}>
                                    <li className="nav-item">
                                        <Link className={setCurrentMainMenu(['manage-customers'], menu, true)} to="/customers/list">
                                            <p className='ml-3'>Customers</p>
                                        </Link>
                                    </li>
                                    </AccessPermission>
                                </ul>
                            </li>
                            </AccessPermission>

                            <AccessPermission requiredPermissions={["superAdmin","inventoryView", "inventoryCreate", "inventoryEdit", "inventoryDelete","inventoryAdjustView","inventoryAdjustCreate","inventoryAdjustEdit","inventoryAdjustDelete","shipmentView","shipmentCreate","shipmentEdit","shipmentDelete","salesReturnView","salesReturnCreate","salesReturnEdit","salesReturnDelete"]}>
                                <li className={setMenuOpen(['manage-item', 'manage-item-form', 'item-brand', 'variant-types', 'manage-inventory-adjustment', 'item-category', 'manage-shipments', 'manage-sales-return'], menu, true)}>
                                    <a className={setCurrentMainMenu(['manage-item', 'manage-item-form', 'item-brand', 'variant-types', 'manage-inventory-adjustment', 'item-category', 'manage-shipments', 'manage-sales-return'], menu, true)}>
                                        <i className="nav-icon fas fa-tags mr-2" />
                                        <p>Others <i className="right fas fa-angle-left" /></p>
                                    </a>
                                    <ul className="nav nav-treeview">
                                        <AccessPermission requiredPermissions={["superAdmin","inventoryView", "inventoryCreate", "inventoryEdit", "inventoryDelete"]}>
                                        <li className="nav-item">
                                            <Link className={setCurrentSubMenu(['manage-item'], menu, true)} to="/item/list">
                                                <p className='ml-3'>Items</p>
                                            </Link>
                                        </li>
                                        </AccessPermission>
                                        
                                        <AccessPermission requiredPermissions={["superAdmin","inventoryAdjustView","inventoryAdjustCreate","inventoryAdjustEdit","inventoryAdjustDelete"]}>
                                        <li className="nav-item">
                                            <Link className={setCurrentSubMenu(['manage-inventory-adjustment'], menu, true)} to="/inventory-adjustment">
                                                <p className='ml-3'>Inventory Adjustment</p>
                                            </Link>
                                        </li>
                                        </AccessPermission>

                                        <AccessPermission requiredPermissions={["superAdmin","shipmentView","shipmentCreate","shipmentEdit","shipmentDelete"]}>
                                        <li className="nav-item">
                                            <Link className={setCurrentSubMenu(['manage-shipments'], menu, true)} to="/shipments/list">
                                                <p className='ml-3'>Shipments</p>
                                            </Link>
                                        </li>
                                        </AccessPermission>

                                        <AccessPermission requiredPermissions={["superAdmin","salesReturnView","salesReturnCreate","salesReturnEdit","salesReturnDelete"]}>
                                        <li className="nav-item">
                                            <Link className={setCurrentSubMenu(['manage-sales-return'], menu, true)} to="/sales-returns/list">
                                                <p className='ml-3'>Sales Return</p>
                                            </Link>
                                        </li>
                                        </AccessPermission>
                                    </ul>
                                </li>
                            </AccessPermission>

                            <AccessPermission requiredPermissions={["superAdmin","employeeView", "employeeCreate", "employeeEdit", "employeeDelete"]}>
                            <li className={setMenuOpen(['employees'], menu, true)}>
                                <Link className={setCurrentMainMenu(['employees'], menu, true)} to="/hrms/employees/list">
                                    <i className="nav-icon fas fa-users mr-2" />
                                    <p>Employees</p>
                                </Link>
                            </li>
                            </AccessPermission>

                            <AccessPermission requiredPermissions={["superAdmin","inventoryReport", "salesOrderReport", "invoiceReport", "paymentReceiveReport","customerReport", "shipmentReport", "purchaseOrderReport","billReport","purchaseReceiveReport", "vendorReport", "paymentMadeReport","courierReport","serviceHubReport"]}>
                            <li className={setMenuOpen(['reports'], menu, true)}>
                                <Link className={setCurrentMainMenu(['reports'], menu, true)} to="/reports">
                                    <i className="nav-icon fas fa-chart-pie mr-2" />
                                    <p>Reports</p>
                                </Link>
                            </li>
                            </AccessPermission>

                            <AccessPermission requiredPermissions={["superAdmin","categoryView", "categoryCreate", "categoryEdit", "categoryDelete","variantTypeView", "variantTypeCreate", "variantTypeEdit","variantTypeDelete","brandView", "brandCreate", "brandEdit","brandDelete","taxRateView","taxRateCreate","taxRateEdit","taxRateDelete","discountRateView","discountRateCreate","discountRateEdit","discountRateDelete","courierView","courierCreate","courierEdit","courierDelete"]}>
                            <li className={setMenuOpen(['settings'], menu, true)}>
                                <Link className={setCurrentMainMenu(['settings'], menu, true)} to="/settings">
                                    <i className="nav-icon fas fa-cog mr-2" />
                                    <p>Settings</p>
                                </Link>
                            </li>
                            </AccessPermission>

                            <AccessPermission requiredPermissions={["superAdmin","accountView", "accountCreate", "accountEdit", "accountDelete","userView", "userCreate", "userEdit","userDelete","roleView", "roleCreate", "roleEdit","roleDelete"]}>
                                <li className={setMenuOpen(['users', 'roles'], menu, true)}>
                                    <a className={setCurrentMainMenu(['users', 'roles'], menu, true)}>
                                    <MdManageAccounts size={25} className='mr-2' />
                                        <p>Accounts <i className="right fas fa-angle-left" /></p>
                                    </a>
                                    <ul className="nav nav-treeview">
                                        <AccessPermission requiredPermissions={["superAdmin","userView", "userCreate", "userEdit","userDelete"]}>
                                        <li className="nav-item">
                                            <Link className={setCurrentSubMenu(['users'], menu, true)} to="/account/users/manage">
                                                <p className='ml-3'>Users</p>
                                            </Link>
                                        </li>
                                        </AccessPermission>
                                        
                                        {/* <AccessPermission requiredPermissions={["superAdmin","roleView", "roleCreate", "roleEdit","roleDelete"]}>
                                        <li className="nav-item">
                                            <Link className={setCurrentSubMenu(['roles'], menu, true)} to="/account/roles/manage">
                                                <p className='ml-3'>Roles</p>
                                            </Link>
                                        </li>
                                        </AccessPermission> */}
                                    </ul>
                                </li>
                            </AccessPermission>
                        </ul> : ''
                    }
                </nav>
                {/* /.sidebar-menu */}
            </div>
            {/* /.sidebar */}
        </aside>
        </>
    )
}
